module.exports = __webpack_public_path__ + "img/SFProDisplay-Bold.67bcaeec.svg";